import React, { useState } from 'react';
import { Edit2, Check, X } from 'lucide-react';

interface SuggestionCardProps {
  id: string;
  content: string;
  isEditing: boolean;
  onEdit: () => void;
  onSave: (content: string) => void;
  onCancel: () => void;
  onClick: () => void;
}

export const SuggestionCard: React.FC<SuggestionCardProps> = ({
  content,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  onClick,
}) => {
  const [editedContent, setEditedContent] = useState(content);

  const handleSave = () => {
    if (editedContent.trim() && editedContent !== content) {
      onSave(editedContent);
    } else {
      onCancel();
    }
  };

  if (isEditing) {
    return (
      <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
        <textarea
          value={editedContent}
          onChange={(e) => setEditedContent(e.target.value)}
          className="w-full p-2 mb-3 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded focus:ring-2 focus:ring-blue-500 text-gray-900 dark:text-white"
          rows={3}
          autoFocus
        />
        <div className="flex justify-end space-x-2">
          <button
            onClick={onCancel}
            className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
          >
            <X size={16} />
          </button>
          <button
            onClick={handleSave}
            className="p-2 text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300"
          >
            <Check size={16} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="group relative p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-500 cursor-pointer"
      onClick={onClick}
    >
      <p className="text-gray-900 dark:text-white pr-8">
        {content}
      </p>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
        }}
        className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <Edit2 size={14} />
      </button>
    </div>
  );
};